<template>
  <teleport to="body">
    <div class="modal" @click="closeModal" v-if="isOpen">
      <div class="content" @click.stop>
        <font-awesome-icon class="exit" icon="fa-xmark" @click="closeModal" />
        <div class="header">
          <h2>{{ form.title }}</h2>
          <sub>{{ form.desc }}</sub>
        </div>
        <div v-for="question in form.questions" class="form-data">
          <div v-if="question.type == 'radio'" class="radio component">
            <p>{{ question.question }}</p>
            <div v-for="option in question.options" :key="option">
              <input type="radio" :name="option" />
              <label :for="option">{{ option }}</label>
            </div>
          </div>
          <div v-if="question.type == 'textarea'" class="textarea component">
            <label :for="question.question">{{ question.question }}</label>
            <textarea :name="question.question"></textarea>
          </div>
          <div v-if="question.type == 'text'" class="text component">
            <p>{{ question.question }}</p>
            <input />
          </div>
          <div v-if="question.type == 'checkbox'" class="checkbox component">
            <p>{{ question.question }}</p>
            <div v-for="option in question.options" :key="option">
              <input type="checkbox" :name="option" />
              <label :for="option">{{ option }}</label>
            </div>
          </div>
          <div v-if="question.type == 'dropdown'" class="dropdown component">
            <label :for="question.question">{{ question.question }}</label>
            <select :name="question.question">
              <option v-for="option in question.options" :value="option">{{ option }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "PreviewFormModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "confirm"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";
.modal {

  .content {
    width: 60%;
    max-height: 80vh;
    overflow-y: auto;
    background-color: var(--primary-colour);
    border-radius: 0.5rem;
    box-shadow: var(--box-shadow);
    padding: 1.5rem;
    position: relative;

    .exit {
      position: absolute;
      top: 1rem;
      right: 1rem;
      cursor: pointer;
      opacity: 0.5;
      &:hover { opacity: 1; }
    }

    .header {
      margin-bottom: 1rem;
      h2 {
        text-transform: capitalize;
        margin: 0 0 0.25rem;
      }
      sub {
        color: var(--action-colour);
      }
    }

    .form-data {
      margin-bottom: 0.75rem;

      .component {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
        background-color: var(--secondary-colour);
        border-radius: 0.25rem;
        padding: 0.75rem;

        p, label {
          margin: 0;
          text-transform: capitalize;
          font-size: 0.95rem;
        }

        input[type="text"],
        input[type="radio"],
        input[type="checkbox"],
        textarea,
        select {
          border: 1px solid var(--border-colour);
          border-radius: 0.25rem;
          background-color: var(--primary-colour);
          color: var(--text-colour);
          padding: 0.4rem 0.5rem;
          font-size: 0.9rem;
        }

        input:not([type="radio"]):not([type="checkbox"]),
        textarea,
        select {
          width: calc(100% - 1rem);
        }
      }
    }
  }
}
</style>
